import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { UserActivityLogType } from '../apollo/__generated__/graphql.ts';
import { CREATE_USER_ACTIVITY_LOG } from '../apollo/user-activity-log.ts';

type CreateExportLogInput = {
  quizId?: number;
  testId?: number;
  type: UserActivityLogType;
};

export const useCreateExportLog = () => {
  const [createExportLogMutation] = useMutation(CREATE_USER_ACTIVITY_LOG);

  return useCallback(
    async (input: CreateExportLogInput) => {
      try {
        await createExportLogMutation({
          variables: {
            input,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    [createExportLogMutation],
  );
};
